import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Noticepage from "../components/notice"

const Notice = () => (
  <Layout>
    <SEO title="Notices" />
    <Noticepage />
  </Layout>
)

export default Notice
